import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Close',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M13.414 12 4.636 3.222 3.222 4.636 10.586 12l-7.364 7.364 1.414 1.414L13.414 12zm0-2.828 5.95-5.95 1.414 1.414-5.95 5.95-1.414-1.414zm0 5.656 1.414-1.414 5.95 5.95-1.414 1.414-5.95-5.95z" }
      })]
    );
  }
};